import { TopPage } from "@/components/elements/TopPage";
import { AdminUserListTop } from "@/features/admin-user/components/AdminUserListTop";
import { AdminUserTable } from "@/features/admin-user/components/AdminUserTable";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

export const AdminUserPage: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <TopPage
          title="irohana担当者一覧"
          description="irohana studyの管理やデータ制作を実施するメンバーを管理できます。いろはなメンバーのみ登録可能です。"
          enablePageBack={false}
        />
        <Stack gap={3}>
          <AdminUserListTop />
          <AdminUserTable />
        </Stack>
      </Box>
    </Stack>
  );
};
